module.exports = __webpack_public_path__ + "static/media/cu_step01.95c4072d.jpg";